<template>
  <div class="wisdom-subject main">
      <div class="sort-navigate flex-layout">
          <span class="sort-name">专项：</span>
          <ul class="sort-ul">
            <li v-for="(item,index) in navigate" 
                :key="index"
                :class="{'active':active === index}"
                @click="handleClick(item,index)"
                class="sort-item csp">
                {{item.name}}
            </li>
          </ul>
          <div class="sort-search">
            <el-input
              size="mini"
              placeholder="请输入课程名称"
              suffix-icon="el-icon-search"
              v-model="search"
              @change="searchCourse">
            </el-input>
          </div>
      </div>
      <div v-if="courseList.length > 0 && courseList">
        <div class="course-part flex-layout">
          <div class="card csp" v-for="(item,index) in courseList" :key="index" @click="toDetail(item,index)">
              <img :src="downloadURL + item.cover" alt="" class="course-cover" :onerror="defualtImage[Math.floor(Math.random() * 5)]">
              <h4 class="course-name wes">{{item.name || '--'}}</h4>
              <div class="summary flex-align-between">
                <div class="info flex-align">
                  <img :src="downloadURL + item.avatar" alt="" class="tea-avatar" :onerror="defualtAvatar">
                  <span class="tea-name">{{item.teacherName || '--'}}</span>
                </div>
                <span class="time">
                  {{handleTime(item.timeScope) || '--'}}
                </span>
              </div>
          </div>
        </div>
        <div class="pagination-part">
          <pagination v-show="pages.total > 0" 
                      :total="pages.total" 
                      :page.sync="pages.currentPage" 
                      :limit.sync="pages.pageSize"
                      :background="true"
                      @pagination="handlePageChange">
          </pagination>
        </div>
      </div>
      <!-- 无课节-->
      <div class="nothing-box flex-align" v-else>
        <div class="nothing-wrap">
          <img src="@/assets/wisdom/nothing.png" alt="">
          <p>暂无内容</p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props:{
    columnId:{
      type:Number
    }
  },
  data() {
    return {
      defualtAvatar:'this.src="' + require("../../../assets/wisdom/men.png") + '"',
      defualtImage: [ //课程默认图片
          'this.src="' + require("../../../assets/wisdom/course-cover01.jpg") + '"',
          'this.src="' + require("../../../assets/wisdom/course-cover02.jpg") + '"',
          'this.src="' + require("../../../assets/wisdom/course-cover03.jpg") + '"',
          'this.src="' + require("../../../assets/wisdom/course-cover04.jpg") + '"',
          'this.src="' + require("../../../assets/wisdom/course-cover05.jpg") + '"',
      ],
      search:'', //搜索课程
      navigate:[ //分类导航
        {
          name:'全部'
        },
        {
          name:'steam课程'
        },
        {
          name:'项目式学习'
        },
        {
          name:'心理学教育'
        },
      ],
      active:0, //当前被选中的导航
      currentSpecialId:null,
      courseList:[], //课程列表
      pages:{ //分页
        currentPage: 1,
        pageSize:8,
        total:0,
      },
    }
  },
  watch: {
    columnId: {
      handler(newVal,oldVal) {
        if(!newVal) return
        this.getCourseList()
      },
      // immediate: true
    }
  },
  methods: {
    // 切换学科
    handleClick(item,index) {
      this.active = index;
      this.currentSpecialId = item.id
      this.pages.currentPage = 1;
      this.getCourseList();
    },
    // 切换分页
    handlePageChange(data){
      this.pages.currentPage = data.pageIndex
      this.pages.pageSize = data.pageSize
      this.getCourseList();
    },
    // 处理时间格式
    handleTime(time){
      if(!time) return
      time = time.split('~')
      time = time[0].split(' ')
      time = time[0].split('.').join('-')
      return time;
    },
    // 输入搜索
    searchCourse(val){
      console.log(val);
      this.pages.currentPage = 1
      this.getCourseList();
    },
    // 去专项详情（新闻页面）
    toDetail(item,index) {
      this.$router.push(`/yunqiao/special/detail/${item.id}`)
    },
    // 获取专项列表
    async getCategoryList() {
      let resData = await Api.Wisdom.getCategoryList()
      // console.log(resData);
      this.navigate = resData.data
      this.navigate.unshift({
         id: null,
         name: "全部"
      })
      this.getCourseList();
    },
    // 获取专项课程
    async getCourseList() {
       if(!this.columnId) return
       let params = {
         page: this.pages.currentPage,
         limit: this.pages.pageSize,
         categoryId: this.currentSpecialId,
         columnId:this.columnId,
         projectId: Number(sessionStorage.getItem('projectID'))
       }
       params.name = this.search ? this.search : null;
       let resData = await Api.Wisdom.getCourseList(params)
      //  console.log(resData);
       if(!resData.data) return;
       this.courseList = resData.data.list;
       this.pages.total = resData.data.totalCount;
    },
  },
  mounted() {
    this.getCategoryList();
  },
}
</script>

<style lang="less" scoped>
  @import "./less/wisdom_subject.less";
</style>